/**
 * Singleton class with various helper functions
 */
define('utils',['require','date','moment'],function (require) {
    'use strict';
     require('date');
    var moment = require('moment');

    // The coordinates of the center of the United States, default when no destination was entered
    const UNITED_STATES_CENTER = { lat: 39.443256, lng: -98.95734 };

     //require('common/legacy/date'); //TODO: find way to make unit tests require this correctly with just 'date'--if you do full path, then the site doesn't load. Look into browserify so we can use node syntax. Or look into better requirejs-to-node translating practices
    return {
        
        setDefaultSearch: function() {
            var today = moment().format('YYYY-MM-DD');
            var buff = moment().add(1, 'days').format('YYYY-MM-DD');

            var newSearch = {
                region: null,
                mileage: 25,
                adults: 2,
                fromDate: today,
                toDate: buff,
                coMemberBook: "false",
                children: 0,
                childrenAges: [],
            }
            this.setLastSearch(newSearch);
            return newSearch;
        },
        setLastSearch: function(search) {
            $.setLocalItem("search", {time: moment(),items: search});
        },
        getLastSearch: function() {
            var data = $.getLocalItem("search");
            // check time out period
            if (data == null || moment().diff(data.time, 'minutes') >= 20) {
                return this.setDefaultSearch();
            }
            return data.items;
        },
        setLastViewedRegion: function(mapView) {
            $.setLocalItem('viewed-region', {time: moment(), items: mapView});
        },
        getLastViewedRegion: function() {
            var data = $.getLocalItem('viewed-region');
            if (data == null || moment().diff(data.time, 'minutes') >= 20) {
                var noClickedRegion = {
                    region: null,
                    zoom: 5,
                    center: UNITED_STATES_CENTER,
                }
                this.setLastViewedRegion(noClickedRegion);
                return noClickedRegion;
            }
            return data.items;
        },
        setLastViewedDestination: function(destination) {
            $.setLocalItem('last-viewed-destination', {time: moment(), item: destination});
        },
        getLastViewedDestination: function() {
            var data = $.getLocalItem('last-viewed-destination');
            if (data == null || moment().diff(data.time, 'minutes') >= 20) {
                var noViewedDestination = null;
                this.setLastViewedDestination(noViewedDestination);
                return noViewedDestination;
            }
            return data.item;
        },
        setCoMemberBookId: function(coMemberBookId) {
            $.setLocalItem('coMemberBookId', {time: moment(), radioId: coMemberBookId});
        },
        getCoMemberBookId: function() {
            var data = $.getLocalItem('coMemberBookId');
            if (data == null || moment().diff(data.time, 'minutes') >= 20) {
                return 'member-book'; // back to default choice
            }
            return data.radioId;
        },
        setAltMemberName: function(altMemberName) {
            $.setLocalItem('altMemberName', {time: moment(), altMemberName: altMemberName});
        },
        getAltMemberName: function() {
            var data = $.getLocalItem('altMemberName');
            if (data == null || moment().diff(data.time, 'minutes') >= 20) {
                return null; // back to default choice
            }
            return data.altMemberName;
        },
        setDestinationSort: function(selection) {
            $.setLocalItem('destination-sort-direction', {time: moment(), item: selection});
        },
        getDestinationSort: function() {
            var data = $.getLocalItem('destination-sort-direction');
            if (data == null || moment().diff(data.time, 'minutes') >= 20) {
                var defaultSort = 'rand';
                this.setDestinationSort(defaultSort);
                return defaultSort;
            }
            return data.item;
        },
        setLastDestinationsMileage: function(mileage) {
            $.setLocalItem('nearby-destinations-mileage', {time: moment(), item: mileage});
        },
        getLastDestinationsMileage: function() {
            var data = $.getLocalItem('nearby-destinations-mileage');
            if (data == null || moment().diff(data.time, 'minutes') >= 20) {
                var defaultMileage = '150';
                this.setLastDestinationsMileage(defaultMileage);
                return defaultMileage;
            }
            return data.item;
        },
        setMapViewToggle: function(toggle) {
            $.setLocalItem('map-toggle', {time: moment(), display: toggle});
        },
        getMapViewToggle: function() {
            var data = $.getLocalItem('map-toggle');
            if (data == null || moment().diff(data.time, 'minutes') >= 20) {
                this.setMapViewToggle(true);
                return true;
            }
            return data.display;
        },
        /**
         * Determines if the given object is of type string
         */
        isString: function(obj) {
            return Object.prototype.toString.call(obj) === '[object String]';
        },

        /**
         * verify all chars are digits
         * @param {obj} obj 
         * @returns {bool} 
         */
        isInt: function(obj) {
            return /^\d+$/.test(obj);
        },

        /**
         * Determines if the given object is an object: http://jsperf.com/isobject4
         */
        isObject: function(obj) {
            return obj !== null && typeof obj === 'object';
        },

        /**
         * Determines if the given object is of type function
         */
        isFunc: function(obj) {
            return typeof obj === 'function';
        },

        /**
         * Angular's isDate func
         * @param {object} value 
         * @returns {bool} 
         */
        isDate: function(value) {
            return Object.prototype.toString.call(value) === '[object Date]';
        },

        /**
         * Angular's isRegExp func
         * @param {object} value 
         * @returns {bool} 
         */
        isRegExp: function(value) {
            return Object.prototype.toString.call(value) === '[object RegExp]';
        },

        /**
         * Escape user input to be treated as a literal string within a regular expression 
         * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions
         * @param {string} string 
         * @returns {string} 
         */
        escapeRegExp: function(string) {
            return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
        },

        /**
         * Escape the regex string and return a regex instance
         * @param {string} regexString 
         * @returns {regex} 
         */
        parseRegex: function(regexString) {
            return new RegExp(this.escapeRegExp(regexString));
        },

        ///**
        // * IsNaN doesn't handle empty, null, or undefined values
        // * @param {object} value 
        // * @returns {bool} 
        // */
        //isNumber: function(value) {
        //    return value != null && value.toString().trim() !== '' && !isNaN(value);
        //},

        /**
         * Checks an object for an existing property.
         * @param obj {object}
         * @param propertyChain {string} (Can be regex) the path to the property, e.g. 'innerObj.value' OR ['innerObj', 'value']
         * @returns {object} the value or null
         */
        tryGetValue: function(obj, propertyChain) {
            if (obj === undefined || obj === null) {
                return null;
            }
            if (!$.isArray(propertyChain)) {
                propertyChain = propertyChain.split('.');
            }
            var propValue = obj; //initial value is the obj itself...; 
            for (var i = 0; i < propertyChain.length; i++) {
                propValue = propValue[propertyChain[i]];
                if (propValue === undefined || propValue === null) {
                    return null;
                }
            }
            return propValue;
        },

        /**
         * Round a floating point number to the given decimal places
         * @param {decimal} num 
         * @param {int} dec number of decimal places to round to
         * @returns {decimal} 
         */
        roundNumber: function(num, dec) {
            if (!isNaN(num)) {
                var result = Math.round(num * Math.pow(10, dec)) / Math.pow(10, dec);
                return result;
            }
            return 0.00;
        },

        /**
         * Get a parameter value form the querystring. Returns empty string value if not found.
         * @param {string} name 
         * @param {string} qs -- defaults to querystring. Handy override if you want your qs data after the hash for only client-side access
         * @returns {string} 
         */
        querystring: function (name, qs) {
            qs = qs == null ? window.location.search : qs;
            name = name.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]");
            var regexS = "[\\?&]" + name + "=([^&#]*)";
            var regex = new RegExp(regexS);
            var results = regex.exec(qs);
            return results == null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
        },

        /**
        * parse data that's formatted like a querystring into an object. 
        * note we convert numbers, but nothing else.
        * e.g. 'a=2&co=true&ca=1,4&f=1/2/2016&t=1/6/2016' > {a: 2, co: "true", ca: "1,4", f: "1/2/2016", t: "1/6/2016"}
        * @param {string} data 
        * @returns {obj} 
        */
        deserializeQs: function (data) {
            data = data.replace(/^\?/, '');
            if (this.isNullOrWhiteSpace(data)) {
                return {};
            }
            var obj = {};
            data.split('&').forEach(function(val) {
                var values = val.split('=');
                var field = values[0];
                var value = decodeURIComponent(values[1]);
                obj[field] = this.isNullOrWhiteSpace(value) || isNaN(value) ? value : parseFloat(value);
            }.bind(this));
            return obj;
        },

        /**
         * de-parse data into a qs string. Supports only very simple objects--arrays get turned into csv, everything else toString
         * @param {obj} data 
         * @returns {string} 
         */
        serializeQs: function (data) {
            if (!$.isPlainObject(data)) {
                return '';
            }
            var result = [];
            for (var field in data) {
                if (data.hasOwnProperty(field)) {
                    var val = data[field];
                    if (this.isNullOrWhiteSpace(val)) {
                        continue;
                    }
                    var valFinal = Array.isArray(val) ? val.join(',') : val.toString();
                    if (valFinal === '') {
                        continue;
                    }
                    result.push('{0}={1}'.format(field, encodeURIComponent(valFinal)));
                }
            }
            return result.length > 0 ? '?{0}'.format(result.join('&')) : '';
        },

        /**
         * Format a big number to have commas
         * @param {number} num 
         * @returns {string} 
         */
        numberWithCommas: function(num) {
            return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },

        /**
         * Add commas for thousands, dollar sign, and round 2 decimal places
         * Note that if there is only 1 decimal place after rounding, we add a 0. If there is no decimal place, we add '.00'
         * TODO: write tests:
         *  -30 --> '$30.00'
         *  -30.3 --> '$30.30'
         *  -30.335 --> '$30.34'
         * @param {number} num 
         * @param {bool} excludeDollarSign
         * @returns {string} 
         */
        formatMoney: function(num, excludeDollarSign) {
            var formatted = '{0}{1}'.format(excludeDollarSign ? '' : '$', this.numberWithCommas(this.roundNumber(num, 2)));
            if (/\.\d{1}$/.test(formatted)) {
                formatted += '0';
            } else if (!/\./.test(formatted)) {
                formatted += '.00';
            }
            return formatted;
        },

        /**
         * Return a formatted date string from a parseable date string
         * Note we clean up .net's time format, so that Date.parse can get it. e.g.: 2016-01-11T12:08:46.377 --> 2016-01-11 12:08:46 TODO: write test
         * Note that format defaults to 'M/d/yyyy' if not passed
         * @param {String|Date} date 
         * @param {String} format Optional
         * @returns {String} 
         */
        formatDate: function (date, format) {
            if (date == null) {
                return null;
            }
            if (format == null) {
                format = 'M/d/yyyy';
            }
            if (this.isDate(date)) {
                return date.toString(format); //note that 'date' must be overriding native date's toString...
            }
            var parseableDate = date.toString();
            var dotNetDateRegex = /T\d+:\d+:\d+/;
            if (dotNetDateRegex.test(parseableDate)) {
                var dotNetHoursMinutesSeconds = parseableDate.match(dotNetDateRegex)[0];
                parseableDate = parseableDate.replace(/T.+$/, dotNetHoursMinutesSeconds);
            }
            var parsedDate = Date.parse(parseableDate);
            if (parsedDate == null) {
                throw new Error('unable to parse date "{0}"'.format(date));
            }
            return parsedDate.toString(format);
        },

        // parse a date in yyyy-mm-dd format
        parseDate: function(input) {
            if (input !== undefined && input !== "") {
                let parts = input.split('-');
                // new Date(year, month [, day [, hours[, minutes[, seconds[, ms]]]]])
                return new Date(parts[0], parts[1]-1, parts[2]); // Note: months are 0-based
            }
        },
        
        /**
         * 
         * @param {Date object} date 
         * @returns {string} formatted in yyyy-mm-dd
         */
        formatInputDate: function(date) {
            if (this.isDate(date)){
                var yyyy = date.getFullYear().toString();
                var mm = (date.getMonth()+1).toString(); // getMonth() is zero-based
                var dd  = date.getDate().toString();
                return yyyy + '-' + (mm[1]?mm:'0'+mm[0]) + '-' + (dd[1]?dd:'0'+dd[0]); // padding
            }
            return null;
        },

        /**
         * This won't work for functions, but should handle basic DTO objects just fine. Based on angular's copy
         * @param {object} obj 
         * @returns {object} 
         */
        copy: function (obj) {
            if (this.isDate(obj)) {
                return new Date(obj.getTime());
            } else if (this.isRegExp(obj)) {
                var result = new RegExp(obj.source, obj.toString().match(/[^\/]*$/)[0]);
                result.lastIndex = obj.lastIndex;
                return result;
            } else if (Array.isArray(obj)) {
                var copyArray = [];
                for (var i = 0, len = obj.length; i < len; i++) {
                    copyArray.push(this.copy(obj[i]));
                }
                return copyArray;
            } else if (this.isObject(obj)) {
                var copyObj = {};
                for (var prop in obj) {
                    copyObj[prop] = this.copy(obj[prop]);
                }
                return copyObj;
            }
            return obj;
        },

        /**
         * Compares two objects deeply (if they aren't the same ref)
         * Slightly modified version of Angular's equals function
         * @param {object} o1 
         * @param {object} o2 
         * @returns {bool} 
         */
        equals: function (o1, o2) {
            if (o1 === o2) return true;
            if (o1 === null || o2 === null) return false;
            if (o1 !== o1 && o2 !== o2) return true; // NaN === NaN
            var t1 = typeof o1, t2 = typeof o2, length, key, keySet;
            if (t1 == t2) {
                if (t1 == 'object') {
                    if (Array.isArray(o1)) {
                        if (!Array.isArray(o2)) return false;
                        if ((length = o1.length) == o2.length) {
                            for (key = 0; key < length; key++) {
                                if (!this.equals(o1[key], o2[key])) return false;
                            }
                            return true;
                        }
                    } else if (this.isDate(o1)) {
                        if (!this.isDate(o2)) return false;
                        return this.equals(o1.getTime(), o2.getTime());
                    } else if (this.isRegExp(o1)) {
                        return this.isRegExp(o2) ? o1.toString() == o2.toString() : false;
                    } else {
                        if (this._isWindow(o1) || this._isWindow(o2) ||
                          Array.isArray(o2) || this.isDate(o2) || this.isRegExp(o2)) return false;
                        keySet = {};
                        for (key in o1) {
                            if (key.charAt(0) === '$' || this.isFunc(o1[key])) continue;
                            if (!this.equals(o1[key], o2[key])) return false;
                            keySet[key] = true;
                        }
                        for (key in o2) {
                            if (!(key in keySet) &&
                                key.charAt(0) !== '$' &&
                                o2[key] !== undefined &&
                                !this.isFunc(o2[key])) return false;
                        }
                        return true;
                    }
                }
            }
            return false;
        },

        /**
         * Throttles the function so it can only be called once 
         * per delay and use the last call to it when it executes
         * source: https://remysharp.com/2010/07/21/throttling-function-calls
         * @param {function} fn 
         * @param {int} delay in milliseconds
         * @returns {function} 
         */
        debounce: function(fn, delay) {
            var timer = null;
            return function() {
                var context = this, args = arguments;
                clearTimeout(timer);
                timer = setTimeout(function() {
                    fn.apply(context, args);
                }, delay);
            };
        },

        isNullOrWhiteSpace: function(value) {
            return value == null || (this.isFunc(value.trim) && value.trim() === '');
        },

        /**
         * Scroll to the givent elemnt on the page
         * http://stackoverflow.com/questions/6677035/jquery-scroll-to-element
         * @param {string} elementId 
         */
        scrollToElement: function(elementId) {
            if (!this.isNullOrWhiteSpace(elementId)) {
                var element = $('#' + elementId);
                if (element.length > 0) {
                    $('html, body').animate({
                        scrollTop: element.offset().top
                    }, 500);
                    element.css('background-color', 'yellow');
                }
            }
        },

        /**
         * Angular's isWindow func
         * @param {object} obj 
         * @returns {bool} 
         */
        _isWindow: function(obj) {
            obj && obj.window === obj;
        }
    };
});
